import * as React from 'react'
import Box from '@mui/material/Box'

import { InfoIcon, LightTooltip } from '@sales-center/components'

interface Props {
  title: string
}

export const AutoCloseInfoTooltip: React.FC<Props> = ({ title }) => (
  <LightTooltip
    title={title}
    enterTouchDelay={0}
    leaveTouchDelay={3000}
    disableTouchListener={false}
  >
    <Box
      component="button"
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
      }}
      sx={{
        ml: 0.5,
        border: 'none',
        background: 'transparent',
        padding: 1.5,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        borderRadius: '50%',
        '&:focus-visible': {
          outline: (theme) => `2px solid ${theme.palette.primary.main}`,
          outlineOffset: 2,
        },
      }}
    >
      <InfoIcon width="16" height="16" />
    </Box>
  </LightTooltip>
)
